import type { Route } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

import { AuthFailureGuard, AuthLogoutGuard } from '@evc/platform';
import type { ImportAsyncComponent } from '@shared/types/utils.type';

const importPageNotFoundComponent: ImportAsyncComponent = () =>
  import('@shared/components/page-not-found/page-not-found.component').then(
    (m) => m.PageNotFoundComponent,
  );

const devicesComponent: ImportAsyncComponent = () =>
  import('./pages/devices/devices.component').then((m) => m.DevicesComponent);

export const appRoutes: Route[] = [
  {
    path: 'logout',
    canActivate: [AuthLogoutGuard],
    loadComponent: importPageNotFoundComponent,
    data: { logout: true },
  },
  {
    path: 'auth-fail',
    canActivate: [AuthFailureGuard],
    loadComponent: importPageNotFoundComponent,
  },
  {
    path: '',
    pathMatch: 'full',
    loadComponent: devicesComponent,
    canActivate: [MsalGuard],
  },
  {
    path: '**',
    loadComponent: importPageNotFoundComponent,
    canActivate: [MsalGuard],
  },
];
